import React from "react";

import { BhHomepageMain } from "./pages/BhHomepageMain";

const App = () => {
    return (
        <div style={{
            width: '1524px',   /* 너비를 1524px로 설정 */
            margin: '0 auto'    /* 가로축 가운데 정렬 */
        }}>
            <BhHomepageMain />
        </div>
    )
}

export default App;